import { ChannelEnum } from "@c2b/muven-commons"

export class ChannelModel {
    name:string = ''
    platform:string = ''
    enumChannel:ChannelEnum
    isActive:boolean = false

    constructor(c?:Partial<ChannelModel>) {
        Object.assign(this, c)
    }
}
